import {PhoneHQButton, PhoneHQInput, PhoneHQModal} from 'ch3-ui-lib';
import {useState} from "react";
import {useGetApiKeyQuery, useUpdateApiKeyMutation} from "../../../store/features/integrations/integrationsService.ts";
import {showToast} from "../../../store/features/Notifications/notificationsSlice.tsx";
import {useAppDispatch} from "../../../store/store.ts";

interface EditApiKeyModalProps {
    id: number | string;
}

const EditApiKeyModal = ({id}: EditApiKeyModalProps) => {
    const dispatch = useAppDispatch();
    const {data: apiKey} = useGetApiKeyQuery(Number(id));
    const [updateApiKey, {isLoading}] = useUpdateApiKeyMutation();
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');

    const openDialog = () => {
        setName(apiKey?.name ?? '');
        setOpen(true);
    };

    const save = async () => {
        if (!apiKey) return;
        try {
            await updateApiKey({data: {...apiKey, name: name.trim()}, id: Number(apiKey.id)}).unwrap();
            dispatch(showToast({description: 'Api Key updated successfully', type: 'success'}));
            setOpen(false);
        } catch {
            dispatch(showToast({description: 'Api Key update failed', type: 'error'}));
        }
    };

    return (
        <>
            <PhoneHQButton variant="text" onClick={openDialog} className="p-0" phq-id='editApiKeyModal-editApiKeyTriggerBtn'>Edit</PhoneHQButton>
            <PhoneHQModal
                open={open}
                onOpenChange={setOpen}
                title="Change display name"
                width={460}
                footer={
                    <>
                        <PhoneHQButton variant="secondary" className="px-5" onClick={() => setOpen(false)}>Cancel</PhoneHQButton>
                        <PhoneHQButton className="px-5" disabled={isLoading || !name.trim()} onClick={save}>Save</PhoneHQButton>
                    </>
                }
            >
                <div className="flex flex-col gap-4">
                    <PhoneHQInput phq-id="editApiKeyModal-apiKeyInput" label="API key" disabled value={`••••••••••••••••••••••••••••••••••${apiKey?.apiKeyShortcut ?? ''}`} readOnly/>
                    <PhoneHQInput phq-id="editApiKeyModal-apiKeyNameInput" label="Key name" value={name} onChange={(e) => setName(e.target.value)}/>
                </div>
            </PhoneHQModal>
        </>
    );
};

export default EditApiKeyModal;
